export default "__VITE_ASSET__rcFYogjO__"